import React, { useContext, useMemo, useState } from 'react';
import { Details } from './Details';
import { IMediaProps } from './IMediaProps';
import { instanceContext } from '../../../contexts/instance';
import { styled } from '@mui/material/styles';
import classNames from 'classnames';

export const Image = styled(
	({ className, ...props }: IMediaProps) => {
		const { children, resource } = props;
		const { instance: provider } = useContext(instanceContext);
		const url = useMemo(() => {
			return provider?.getResourceUrl(resource);
		}, [resource, provider]);

		const { name } = resource;

		const [ref, setRef] = useState<HTMLImageElement | null>(null);

		if (!url) return null;
		return (
			<>
				<figure className={classNames('message__image', className)}>
					<img src={url} alt={name} onLoad={(ev) => setRef(ev.currentTarget)} />
				</figure>
				<Details
					{...props}
					description={
						ref ? (
							<ImageSize
								width={ref?.naturalWidth}
								height={ref?.naturalHeight}
							/>
						) : undefined
					}
				>
					{children}
				</Details>
			</>
		);
	},
	{
		target: 'Image-root',
		label: 'Image',
	},
)({
	margin: 0,
	padding: 0,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',

	'& img': {
		width: 'auto',
		height: 'auto',
		maxWidth: '100%',
		maxHeight: '100%',
		alignSelf: 'center',
		overflow: 'hidden',
	},
});

export const ImageSize = ({
	width,
	height,
}: {
	width: number;
	height: number;
}) => (
	<span className="image__size">
		({width}x{height})
	</span>
);
